const NOT_A_DEAL = "Not a Deal";

export const buildDealsFromStocks = ({ stocks, stockDealMap }: { stocks: string[]; stockDealMap: Map<string, string> }) => {
	const seenStocks = new Set<string>();
	return stocks
		.map((stock) => {
			const dealFromApi = stockDealMap.get(stock);

			return {
				stockNumber: stock,
				dealNumber: dealFromApi ?? NOT_A_DEAL,
			};
		})
		.filter((deal) => {
			if (seenStocks.has(deal.stockNumber)) {
				return false;
			}
			seenStocks.add(deal.stockNumber);
			return true;
		});
};

export const buildDealsFromDeals = ({
	deals,
	dealStockMap,
}: {
	deals: { label: string; stockNumber: string }[];
	dealStockMap: Map<string, string>;
}) => {
	return deals.map((deal) => {
		const stockFromApi = dealStockMap.get(deal.label) || deal.stockNumber;

		return {
			stockNumber: stockFromApi ?? "",
			dealNumber: deal.label,
		};
	});
};
